import AssignPatientsModal from './AssignPatientsModal';

export default AssignPatientsModal;
